import React from 'react';

import gridWidth from '../shared/grid-width';

import type { PrismicRichContent } from '../../../../../types';

import * as S from './styles';

type Props = {
  textBefore: Array<PrismicRichContent>;
  textAfter: Array<PrismicRichContent>;
  gridLayout: string;
};

const TextText = ({ textBefore, textAfter, gridLayout }: Props) => {
  const width = gridWidth(gridLayout);

  return (
    <S.TextText>
      <S.TextBefore data={textBefore} width={width[0]} />
      <S.TextAfter data={textAfter} width={width[1]} />
    </S.TextText>
  );
};

export default TextText;
